import React from 'react';
import classnames from 'classnames';
import { progressClass } from './styles';
import analyzeColor from './analyzeColor';
import Popup from './Popup';
import { isRTL } from '../config';
var DefaultValue = {
  strokeWidth: 8
};

function Line(props) {
  var children = props.children,
      _props$strokeWidth = props.strokeWidth,
      strokeWidth = _props$strokeWidth === void 0 ? DefaultValue.strokeWidth : _props$strokeWidth,
      type = props.type,
      value = props.value,
      color = props.color,
      style = props.style,
      background = props.background,
      popup = props.popup;
  var hasChildren = children !== undefined;
  var isPopup = popup && hasChildren;
  var className = classnames(progressClass('line', type, isPopup && 'line-popup', isRTL() && 'rtl'), props.className);
  var innerStyle = {
    width: "".concat(value / 100 * 100, "%"),
    borderRadius: strokeWidth / 2
  };

  if (typeof color === 'string') {
    innerStyle.background = color;
    innerStyle.backgroundSize = '1em 1em';
  } else if (typeof color === 'object') {
    innerStyle.background = "linear-gradient(to right, ".concat(analyzeColor(color).reduce(function (p, v) {
      var col = "".concat(v.color, " ").concat(v.pos);
      return p ? "".concat(p, ",").concat(col) : col;
    }, ''), ")");
  }

  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: className,
      style: style
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: progressClass('background'),
      style: {
        height: strokeWidth,
        background: background,
        borderRadius: strokeWidth / 2
      }
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: progressClass('front'),
      style: innerStyle
    })), hasChildren && (popup ?
    /*#__PURE__*/
    React.createElement(Popup, Object.assign({}, props, {
      value: value
    })) :
    /*#__PURE__*/
    React.createElement("div", {
      className: progressClass('content')
    }, children)))
  );
}

Line.defaultProps = DefaultValue;
export default Line;